type Config = {
  abeet_base_url: string;
};

declare const CONFIG: Config;

export const ABEET_HOST = CONFIG.abeet_base_url;
